<nz-card>
  <div nz-row nzType="flex">
    <div class="sm-screen-full-width">
      <div class="center-content">
        <div class="image-container">
          <ng-container *ngTemplateOutlet="imageTemplate"></ng-container>
        </div>
      </div>
      <div class="center-content">
        <div class="contact-seller-container">
          <div class="seller-name">
            <div *ngIf="seller && seller.logo" class="seller-image-container">
              <img class="seller-image" alt="Seller Image" [src]="seller.logo">
            </div>
            <div class="seller-name-text">
              <span>{{ seller.displayName || 'N/A' }}</span>
              <a href="/seller/page/{{seller.name}}">View Profile</a>
            </div>
          </div>
          <button *ngIf="(isLogged$ | async)" class="margin-top-10" nz-button nzType="default"
            (click)="contactSeller()">
            <i nz-icon type="mail"></i><span>Contact Seller</span>
          </button>
        </div>
      </div>
    </div>

    <div style="flex-grow: 2; margin-left: 20px; width: 60%">
      <ng-container
        *ngTemplateOutlet="detailsTemplate; context: { name: name, sku: sku, type: type, suffix: suffix, restriction: restriction }">
      </ng-container>
    </div>
  </div>
</nz-card>

<ng-template #detailsTemplate let-name=name let-sku=sku let-type=type let-restriction=restriction let-suffix="suffix">
  <h3>{{ name }} {{suffix ? ' - ' + suffix : ''}}</h3>

  <div *leapHasGroup="['buyer']">
    <nz-alert *ngIf="restriction?.restricted && !restriction?.hasAccess && !restriction?.isNotContractedSupplier"
      nzType="warning" [nzMessage]="restrictionMessageTemplate"></nz-alert>
    <nz-alert *ngIf="restriction?.isNotContractedSupplier" nzType="warning"
      [nzMessage]="isNotContractedSupplierMessage"></nz-alert>
    <!-- /* TODO: restriction?.restricted && !restriction?.hasAccess */ -->
  </div>

  <leap-expiring-contract-alert *ngIf="expiringContract?.expiryDate" [templateId]="expiringContract.template?.id"
    [expiryDate]="expiringContract.expiryDate"></leap-expiring-contract-alert>

  <div style="display: flex; align-items: center;">
    <div style="display: flex">
      <div class="label">Product ID <ng-container *ngTemplateOutlet="productIdHint"></ng-container> :</div>
      <div class="value">{{ isBundleType ? bundle?.sku : sku }}</div>
    </div>
    <div class="separator"></div>
    <div style="display: flex">
      <div class="label">Product Type:</div>
      <div class="value">{{ type }}</div>
    </div>
  </div>
  <div style="display: flex" *ngIf="courseDeliveryFormats">
    <div class="label with-hint">{{ deliveryFormatLabel }} Delivery Formats:
      <ng-container *ngTemplateOutlet="hint"></ng-container>
    </div>
    <div class="values">
      <span *ngFor="let format of courseDeliveryFormats;let last = last" class="value">
        {{ format.configValue }}{{ last ? '' : ','}}
      </span>
    </div>
  </div>
  <div class="badges-container">
    <!-- <div class="badge leapest-recommended">
      Leapest <span>Recommended</span>
    </div> -->
  </div>

  <hr class="horizontal-separator">

  <div class="choose-variant-container">
    <ng-container *ngIf="!isBundleType; else bundleTemplate">
      <h5>Choose your variant</h5>
      <leap-choose-variant-form [languages]="languages" [deliveryFormats]="deliveryFormats"
        [certificateTypes]="certificateTypes">
      </leap-choose-variant-form>
    </ng-container>

    <ng-template #bundleTemplate>
      <leap-bundle-license-form [bundleLicenses]="bundle?.licensePricing"></leap-bundle-license-form>
    </ng-template>
  </div>
</ng-template>

<ng-template #imageTemplate>
  <leap-product-details-image-skeleton *ngIf="imageLoading"></leap-product-details-image-skeleton>
  <div [hidden]="imageLoading">
    <ng-container *ngIf="imageUrl && !brokenImage; else imagePlaceholder">
      <img class="product-image" alt="Product Image" [src]="imageUrl" (load)="imageLoading = false"
        (error)="imageLoading = false; brokenImage = true">
    </ng-container>
    <ng-template #imagePlaceholder>
      <div class="image-placeholder"> Image Placeholder </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #restrictionMessageTemplate>
  <span class="inner-html" [innerHTML]="restrictionMessage"></span>
</ng-template>

<ng-template #hint>
  <div class="show-tooltip">
    <svg version="1.2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" overflow="visible"
      preserveAspectRatio="none" viewBox="0 0 514 514" width="12" height="12">
      <g transform="translate(1, 1)">
        <path
          d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
          vector-effect="non-scaling-stroke" style="fill: rgb(142, 143, 166);" />
      </g>
    </svg>
    <span class="tooltiptext">Course Delivery Formats suitable for this product</span>
  </div>
</ng-template>

<ng-template #isNotContractedSupplierMessage>
  Your account is set to only allow procurement from contracted suppliers. {{sellerName}} does not have an agreement
  with your organization. Please contact your account administrator if you are interested in this product or service.
</ng-template>

<ng-template #productIdHint>
  <div class="show-tooltip">
    <svg version="1.2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" overflow="visible"
      preserveAspectRatio="none" viewBox="0 0 514 514" width="12" height="12">
      <g transform="translate(1, 1)">
        <path
          d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
          vector-effect="non-scaling-stroke" style="fill: rgb(142, 143, 166);" />
      </g>
    </svg>
    <span class="tooltiptext"
      i18n="identification code for product id in product details|@@main.details.productId.info.text">Identification
      code assigned to this product. Please note that each Product ID can be associated with multiple SKUs (one per
      product variant).</span>
  </div>
</ng-template>